// src/data/leagueData.js

export const leagues = {
  current10: {
    id: "current10",
    label: "2026 — 10 Team League",
    financials: {
      entryFee: 500,
      totalPot: 5000,
      payouts: {
        weekly: {
          label: "Weekly High Score Pool",
          amount: 1200,
          note: "Pays out weekly",
        },
        regularSeason: { label: "Reg. Season Champ", amount: 800 },
        runnerUp: { label: "Playoff Runner Up", amount: 900 },
        champion: { label: "League Champion", amount: 2100 },
      },
    },
    teams: [
      {
        id: "hurts-donut",
        name: "Hurts Donut",
        owner: "TJ",
        seed: 1,
        madePlayoffs: true,
        finish: ["regular_season_champ", "champion"], // Won both titles
      },
      {
        id: "pencil",
        name: "Pencil in a W",
        owner: "Mike Finn",
        seed: 2,
        madePlayoffs: true,
      },
      {
        id: "mustache",
        name: "Mustache Rides",
        owner: "Eric Belcher",
        seed: 3,
        madePlayoffs: true,
      },
      {
        id: "tomlins",
        name: "Tomlin’s Boys",
        owner: "Matthew",
        seed: 4,
        madePlayoffs: true,
        finish: ["third_place"], // Based on 3rd place game win
      },
      {
        id: "sprouts",
        name: "Sprouts",
        owner: "Chase, Brayden, and Ben",
        seed: 5,
        madePlayoffs: true,
      },
      {
        id: "armed",
        name: "Armed Rodgery",
        owner: "Colton",
        seed: 6,
        madePlayoffs: true,
        finish: ["runner_up"], // Finalist
      },
      {
        id: "betterluck",
        name: "BetterLUCKnextYear",
        owner: "Mike Kelly",
        seed: 7,
        madePlayoffs: false,
      },
      {
        id: "last-dance",
        name: "Last Dance",
        owner: "Ed",
        seed: 8,
        madePlayoffs: false,
      },
      {
        id: "grogans",
        name: "Grogan's Hero's",
        owner: "Roger",
        seed: 9,
        madePlayoffs: false,
      },
      {
        id: "benihanas",
        name: "Benihanas",
        owner: "Ben Belcher",
        seed: 10,
        madePlayoffs: false,
      },
    ],
    playoffs: {
      seeds: [1, 2, 3, 4, 5, 6],
      rounds: [
        {
          id: "qf",
          label: "Quarterfinals",
          matchups: [
            {
              id: "qf1",
              homeSeed: 4,
              awaySeed: 5,
              homeScore: 123.32,
              awayScore: 118.3,
              winnerSeed: 4,
            },
            {
              id: "qf2",
              homeSeed: 3,
              awaySeed: 6,
              homeScore: 122.54,
              awayScore: 164.4,
              winnerSeed: 6,
            },
          ],
        },
        {
          id: "sf",
          label: "Semifinals",
          matchups: [
            {
              id: "sf1",
              homeSeed: 1,
              awayFrom: "qf1",
              homeScore: 123.26,
              awayScore: 87.6,
              winnerSeed: 1,
            },
            {
              id: "sf2",
              homeSeed: 2,
              awayFrom: "qf2",
              homeScore: 106.0,
              awayScore: 182.0,
              winnerSeed: 6,
            },
          ],
        },
        {
          id: "final",
          label: "Championship & Consolations",
          matchups: [
            {
              id: "ch",
              label: "Final",
              homeFrom: "sf1",
              awayFrom: "sf2",
              homeScore: 122.92,
              awayScore: 78.9,
              winnerSeed: 1,
            },
            {
              id: "3rd",
              label: "3rd Place",
              homeSeed: 4,
              awaySeed: 2,
              homeScore: 125.98,
              awayScore: 109.64,
              winnerSeed: 4,
            },
            {
              id: "5th",
              label: "5th Place",
              homeSeed: 5,
              awaySeed: 3,
              homeScore: 143.04,
              awayScore: 90.42,
              winnerSeed: 5,
            },
          ],
        },
      ],
    },
    weeks: [
      {
        week: 1,
        label: "Week 1",
        image: "/weeklyscores/week_1.png",
        highScore: { teamId: "benihanas", points: 153.42 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Sprouts",
            scoreA: 153.42,
            scoreB: 90.06,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Pencil in a W",
            scoreA: 100.38,
            scoreB: 100.08,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Armed Rodgery",
            scoreA: 146.96,
            scoreB: 136.88,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Hurts Donut",
            scoreA: 89.12,
            scoreB: 91.82,
          },
          {
            teamA: "Last Dance",
            teamB: "Mustache Rides",
            scoreA: 111.42,
            scoreB: 110.62,
          },
        ],
      },
      {
        week: 2,
        label: "Week 2",
        image: "/weeklyscores/week_2.png",
        highScore: { teamId: "sprouts", points: 191.9 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "BetterLUCKnextYear",
            scoreA: 103.1,
            scoreB: 132.88,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Hurts Donut",
            scoreA: 91.92,
            scoreB: 103.7,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Sprouts",
            scoreA: 93.94,
            scoreB: 191.9,
          },
          {
            teamA: "Last Dance",
            teamB: "Pencil in a W",
            scoreA: 100.88,
            scoreB: 135.5,
          },
          {
            teamA: "Mustache Rides",
            teamB: "Armed Rodgery",
            scoreA: 136.34,
            scoreB: 115.14,
          },
        ],
      },
      {
        week: 3,
        label: "Week 3",
        image: "/weeklyscores/week_3.png",
        highScore: { teamId: "hurts-donut", points: 140.86 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Last Dance",
            scoreA: 103.62,
            scoreB: 113.86,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Sprouts",
            scoreA: 96.32,
            scoreB: 109.72,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Grogan's Hero's",
            scoreA: 132.62,
            scoreB: 99.94,
          },
          {
            teamA: "Mustache Rides",
            teamB: "Hurts Donut",
            scoreA: 133.32,
            scoreB: 140.86,
          },
          {
            teamA: "Pencil in a W",
            teamB: "Armed Rodgery",
            scoreA: 139.22,
            scoreB: 130.34,
          },
        ],
      },
      {
        week: 4,
        label: "Week 4",
        image: "/weeklyscores/week_4.png",
        highScore: { teamId: "armed", points: 164.5 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Armed Rodgery",
            scoreA: 121.04,
            scoreB: 164.5,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Grogan's Hero's",
            scoreA: 133.56,
            scoreB: 123.32,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Mustache Rides",
            scoreA: 147.66,
            scoreB: 151.08,
          },
          {
            teamA: "Last Dance",
            teamB: "Sprouts",
            scoreA: 151.0,
            scoreB: 70.98,
          },
          {
            teamA: "Pencil in a W",
            teamB: "Hurts Donut",
            scoreA: 103.46,
            scoreB: 116.1,
          },
        ],
      },
      {
        week: 5,
        label: "Week 5",
        image: "/weeklyscores/week_5.png",
        highScore: { teamId: "pencil", points: 178.26 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Hurts Donut",
            scoreA: 108.84,
            scoreB: 125.4,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Last Dance",
            scoreA: 124.08,
            scoreB: 139.42,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Pencil in a W",
            scoreA: 99.62,
            scoreB: 178.26,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Mustache Rides",
            scoreA: 121.72,
            scoreB: 136.98,
          },
          {
            teamA: "Sprouts",
            teamB: "Armed Rodgery",
            scoreA: 152.98,
            scoreB: 110.7,
          },
        ],
      },
      {
        week: 6,
        label: "Week 6",
        image: "/weeklyscores/week_6.png",
        highScore: { teamId: "grogans", points: 154.64 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Tomlin's Boys",
            scoreA: 120.34,
            scoreB: 127.9,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Armed Rodgery",
            scoreA: 125.08,
            scoreB: 89.32,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Last Dance",
            scoreA: 154.64,
            scoreB: 97.88,
          },
          {
            teamA: "Mustache Rides",
            teamB: "Pencil in a W",
            scoreA: 106.66,
            scoreB: 151.74,
          },
          {
            teamA: "Hurts Donut",
            teamB: "Sprouts",
            scoreA: 120.22,
            scoreB: 103.16,
          },
        ],
      },
      {
        week: 7,
        label: "Week 7",
        image: "/weeklyscores/week_7.png",
        highScore: { teamId: "sprouts", points: 188.48 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Mustache Rides",
            scoreA: 87.64,
            scoreB: 111.08,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Hurts Donut",
            scoreA: 92.44,
            scoreB: 149.94,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Sprouts",
            scoreA: 136.86,
            scoreB: 188.48,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Pencil in a W",
            scoreA: 135.58,
            scoreB: 139.32,
          },
          {
            teamA: "Last Dance",
            teamB: "Armed Rodgery",
            scoreA: 130.54,
            scoreB: 117.34,
          },
        ],
      },
      {
        week: 8,
        label: "Week 8",
        image: "/weeklyscores/week_8.png",
        highScore: { teamId: "pencil", points: 169.64 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Pencil in a W",
            scoreA: 110.68,
            scoreB: 169.64,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Tomlin's Boys",
            scoreA: 166.68,
            scoreB: 86.52,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Armed Rodgery",
            scoreA: 118.18,
            scoreB: 156.26,
          },
          {
            teamA: "Last Dance",
            teamB: "Hurts Donut",
            scoreA: 96.36,
            scoreB: 134.3,
          },
          {
            teamA: "Mustache Rides",
            teamB: "Sprouts",
            scoreA: 95.72,
            scoreB: 146.62,
          },
        ],
      },
      {
        week: 9,
        label: "Week 9",
        image: "/weeklyscores/week_9.png",
        highScore: { teamId: "tomlins", points: 176.82 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Grogan's Hero's",
            scoreA: 104.92,
            scoreB: 115.66,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Mustache Rides",
            scoreA: 111.78,
            scoreB: 129.44,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Last Dance",
            scoreA: 176.82,
            scoreB: 99.9,
          },
          {
            teamA: "Pencil in a W",
            teamB: "Sprouts",
            scoreA: 124.8,
            scoreB: 125.46,
          },
          {
            teamA: "Hurts Donut",
            teamB: "Armed Rodgery",
            scoreA: 149.96,
            scoreB: 93.84,
          },
        ],
      },
      {
        week: 10,
        label: "Week 10",
        image: "/weeklyscores/week_10.png",
        highScore: { teamId: "pencil", points: 167.62 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Sprouts",
            scoreA: 133.8,
            scoreB: 85.84,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Pencil in a W",
            scoreA: 124.0,
            scoreB: 167.62,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Armed Rodgery",
            scoreA: 124.84,
            scoreB: 106.42,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Hurts Donut",
            scoreA: 113.7,
            scoreB: 126.1,
          },
          {
            teamA: "Last Dance",
            teamB: "Mustache Rides",
            scoreA: 112.6,
            scoreB: 139.68,
          },
        ],
      },
      {
        week: 11,
        label: "Week 11",
        image: "/weeklyscores/week_11.png",
        highScore: { teamId: "tomlins", points: 158.48 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "BetterLUCKnextYear",
            scoreA: 133.2,
            scoreB: 130.78,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Hurts Donut",
            scoreA: 158.48,
            scoreB: 108.7,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Sprouts",
            scoreA: 140.94,
            scoreB: 82.02,
          },
          {
            teamA: "Last Dance",
            teamB: "Pencil in a W",
            scoreA: 79.64,
            scoreB: 117.62,
          },
          {
            teamA: "Mustache Rides",
            teamB: "Armed Rodgery",
            scoreA: 105.42,
            scoreB: 131.6,
          },
        ],
      },
      {
        week: 12,
        label: "Week 12",
        image: "/weeklyscores/week_12.png",
        highScore: { teamId: "last-dance", points: 150.78 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Last Dance",
            scoreA: 114.12,
            scoreB: 150.78,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Sprouts",
            scoreA: 149.08,
            scoreB: 125.22,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Grogan's Hero's",
            scoreA: 109.92,
            scoreB: 78.26,
          },
          {
            teamA: "Mustache Rides",
            teamB: "Hurts Donut",
            scoreA: 122.76,
            scoreB: 95.22,
          },
          {
            teamA: "Pencil in a W",
            teamB: "Armed Rodgery",
            scoreA: 138.14,
            scoreB: 132.86,
          },
        ],
      },
      {
        week: 13,
        label: "Week 13",
        image: "/weeklyscores/week_13.png",
        highScore: { teamId: "grogans", points: 141.38 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Armed Rodgery",
            scoreA: 86.74,
            scoreB: 78.7,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Grogan's Hero's",
            scoreA: 93.04,
            scoreB: 141.38,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Mustache Rides",
            scoreA: 93.32,
            scoreB: 119.46,
          },
          {
            teamA: "Last Dance",
            teamB: "Sprouts",
            scoreA: 82.04,
            scoreB: 122.04,
          },
          {
            teamA: "Pencil in a W",
            teamB: "Hurts Donut",
            scoreA: 137.16,
            scoreB: 135.72,
          },
        ],
      },
      {
        week: 14,
        label: "Week 14",
        image: "/weeklyscores/week_14.png",
        highScore: { teamId: "mustache", points: 140.66 },
        matchups: [
          {
            teamA: "Benihanas",
            teamB: "Hurts Donut",
            scoreA: 91.38,
            scoreB: 110.14,
          },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Last Dance",
            scoreA: 117.14,
            scoreB: 92.6,
          },
          {
            teamA: "Tomlin's Boys",
            teamB: "Pencil in a W",
            scoreA: 126.24,
            scoreB: 94.28,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Mustache Rides",
            scoreA: 113.46,
            scoreB: 140.66,
          },
          {
            teamA: "Sprouts",
            teamB: "Armed Rodgery",
            scoreA: 106.26,
            scoreB: 133.9,
          },
        ],
      },
      {
        week: 15,
        label: "Week 15",
        image: "/weeklyscores/week_15.png",
        highScore: { teamId: "armed", points: 164.4 },
        matchups: [
          {
            teamA: "Tomlin's Boys",
            teamB: "Sprouts",
            scoreA: 123.32,
            scoreB: 118.3,
          },
          {
            teamA: "Mustache Rides",
            teamB: "Armed Rodgery",
            scoreA: 122.54,
            scoreB: 164.4,
          },
          {
            teamA: "Pencil in a W",
            teamB: "Bye",
            scoreA: 130.18,
            scoreB: null,
          },
          { teamA: "Hurts Donut", teamB: "Bye", scoreA: 154.52, scoreB: null },
          { teamA: "Benihanas", teamB: "Bye", scoreA: 115.58, scoreB: null },
          {
            teamA: "BetterLUCKnextYear",
            teamB: "Bye",
            scoreA: 162.66,
            scoreB: null,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Bye",
            scoreA: 125.4,
            scoreB: null,
          },
          { teamA: "Last Dance", teamB: "Bye", scoreA: 98.86, scoreB: null },
        ],
      },
      {
        week: 16,
        label: "Week 16",
        image: "/weeklyscores/week_16.png",
        highScore: { teamId: "armed", points: 112.1 },
        matchups: [
          {
            teamA: "Tomlin's Boys",
            teamB: "Hurts Donut",
            scoreA: 33.5,
            scoreB: 87.28,
          },
          {
            teamA: "Pencil in a W",
            teamB: "Armed Rodgery",
            scoreA: 83.8,
            scoreB: 112.1,
          },
          {
            teamA: "Benihanas",
            teamB: "BetterLUCKnextYear",
            scoreA: 94.82,
            scoreB: 83.0,
          },
          {
            teamA: "Grogan's Hero's",
            teamB: "Last Dance",
            scoreA: 80.56,
            scoreB: 81.7,
          },
          {
            teamA: "Mustache Rides",
            teamB: "Sprouts",
            scoreA: 83.12,
            scoreB: 71.3,
          },
        ],
      },
    ],
  },
  legacy12: {
    id: "legacy12",
    label: "Legacy — 12 Team League",
    financials: {
      entryFee: 500,
      totalPot: 6000,
      payouts: {
        weekly: { label: "Weekly Pool", amount: 1400, note: "Historical" },
        regularSeason: { label: "Reg. Season Champ", amount: 1000 },
        runnerUp: { label: "Playoff Runner Up", amount: 1100 },
        champion: { label: "League Champion", amount: 2500 },
      },
    },
    teams: [
      {
        id: "leg1",
        name: "Legacy Team A",
        owner: "Owner A",
        seed: 1,
        madePlayoffs: true,
        finish: ["champion"],
      },
      {
        id: "leg2",
        name: "Legacy Team B",
        owner: "Owner B",
        seed: 2,
        madePlayoffs: true,
      },
    ],
    playoffs: null,
    weeks: [],
  },
};
